<template>
  <span class="currency" :class="className">
    {{currencyString}}</span>
</template>

<script>
import currencySymbol from "@/mixins/currencySymbol"
export default {
  mixins:[currencySymbol],
  props: {
    fixed: {
      default: false,
      type: Boolean
    },
    value: {
      default: 0
    },
    className: {
      default: ""
    }
  }, //["value", "fixed"], // properties are coming from the parent componant

  data: function() {
    return {
      modal: {
        show: false,
        body: "",
      }
    };
  },

  computed: {
    currencyString() {
      return this.myCurrency < 0 ? "-" + this.currency_symbol + -1 * this.myCurrency : this.currency_symbol + this.myCurrency
    },
    myCurrency: function() {
      let v = this.value;

      if (v) {
        if (Number.isInteger(v) && !this.fixed) {
          //return v;
          return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        v = (v * 1).toFixed(2);
        v = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        //console.log("-------------- Currency --------------", v);
        return v;
      }
      //
      else {
        return 0.0;
      }
    }
  },

  methods: {},

  mounted: function() {
    /*
			var n = this.$slots.default[0].text;

			n = this.formatMoney(n/1, 2, '.', ',');

			this.$refs.currencySlot.innerHTML = '$'+n;
*/
  }
};
</script>

<style lang="scss"></style>
